import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import * as searchAction from "../../actions/search";
import SearchService from "../../services/searchService";

import LogoImg from "../../../assets/images/ic_iids-logo.svg";
import LogoNepStat from "../../../assets/images/nep-stat-logo.png";

class Navbar extends React.Component {
  // constructor(props) {
  //     super(props);
  // }
  render() {
    // const data = {
    //   "@context": "http://schema.org",

    //   "@type": "DataCatalog",

    //   name: "nepstat",

    //   alternateName: "Development Timeseries Data of Nepal",

    //   url: "https://nepstat.iids.org.np/",

    //   publisher: {
    //     "@type": "Organization",

    //     name: "Institute For Integrated Development Studies",

    //     url: "http://www.iids.org.np/"
    //   }
    // };
    return (
      <Nav>
        {/* <Helmet>
          <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Helmet> */}
        {/* Header */}
        <div className="header">
          <div className="header__inner">
            {/* Logo */}
            <Brand>
              <div className="brand__logo">
                <Link to="/" className="first__logo">
                  <img src={LogoNepStat} alt="Nepal Statistics" />
                </Link>
                <a
                  target="_blank"
                  href="http://www.iids.org.np/"
                  className="second__logo"
                >
                  <img
                    src={LogoImg}
                    alt="Institute for Integrated Development Studies "
                  />
                </a>
              </div>
              <div className="slogan">DATA DRIVEN DEVELOPMENT DISCOURSE</div>
            </Brand>

            {/* Primary Menu */}
            <PrimaryNav>
              <div className="nav-menu">
                <ul className="nav">
                  <li className="nav__item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="nav__item">
                    <Link to="/about">About</Link>
                  </li>
                  <li className="nav__item">
                    <Link to="/geodata">NepStat-Geo</Link>
                  </li>
                </ul>
              </div>
              <div className="search-wrap">
                <div className="search">
                  {/* <SearchBar page="home" onChange={this.handleOnChange} /> */}
                  <input
                    type="text"
                    className="form-search"
                    placeholder="Search..."
                    onKeyPress={event => {
                      let query = event.target.value;
                      if (event.key === "Enter") {
                        this.props.history.push(`/search?str=${query}`);

                        this.props.searchData(`?str=${query}`);
                      }
                    }}
                  />
                  <div className="search-icon" />
                </div>
              </div>
            </PrimaryNav>
          </div>
        </div>
      </Nav>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchData: str => {
    dispatch(searchAction.fetching());
    SearchService.searchData(str)
      .then(response => {
        dispatch(searchAction.fetched(response));
      })
      .catch(error => {
        dispatch(searchAction.error({ error }));
      });
  }
});

export default connect(null, mapDispatchToProps)(withRouter(Navbar));

const Nav = styled.div`
  .header {
    padding: 18px;

    @media only screen and (min-width: 480px) {
      padding: 20px;
    }

    @media only screen and (min-width: 992px) {
      padding: 20px 60px;
    }

    @media only screen and (min-width: 1024px) {
      padding: 20px 55px;
    }

    &__inner {
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;

      @media only screen and (min-width: 992px) {
        justify-content: space-between;
      }
    }
  }
`;

const Brand = styled.div`
  .brand__logo {
    display: flex;
    max-width: 100%;

    img {
      height: 40px;
      width: 150px;
      display: block;
    }

    .first__logo {
      border-right: solid;
      border-right-color: #9b9b9b;
      padding-right: 10px;
    }

    .second__logo {
      margin-left: 10px;
    }
  }

  .slogan {
    margin-top: 20px;
    font-size: 14px;
    color: #9b9b9b;
  }
`;

const PrimaryNav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media only screen and (min-width: 560px) {
    flex-direction: row;
    align-items: center;
    width: initial;
    margin-top: 15px;
  }

  @media only screen and (min-width: 992px) {
    margin-top: 0;
  }

  .nav-menu {
    margin: 0 0 10px 0;

    @media only screen and (min-width: 560px) {
      margin: 0 30px 0 0;
    }

    @media only screen and (min-width: 768px) {
      margin-right: 30px;
      float: left;
    }
  }

  .nav__item {
    display: inline-block;
    margin-right: 30px;

    &:last-child {
      margin-right: 0;
    }

    a {
      display: block;
      font-size: 14px;
      text-decoration: none;
      color: #4a4a4a;
      font-weight: 500;
      transition: all 0.25s ease-in-out;

      &:hover,
      &:focus {
        color: #000;
        font-weight: 800;
        transition: all 0.25s ease-in-out;
      }

      &.active {
        color: #000;
      }
    }
  }

  .search-wrap {
    float: left;
    position: relative;

    input {
      width: 240px;
      padding-right: 30px;
    }
  }

  .search-icon {
    color: #000;
    position: absolute;
    top: 10px;
    right: 15px;
    margin-top: 2px;
    margin-left: 3px;
    width: 12px;
    height: 12px;
    border: solid 1px currentColor;
    border-radius: 100%;
    transform: rotate(-45deg);

    &:before {
      content: "";
      position: absolute;
      top: 11px;
      left: 5px;
      height: 6px;
      width: 1px;
      background-color: currentColor;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.js